import { SetStateAction } from 'react';

import { SelectedG500LiteMasterInfoType } from '../../../common/component/hooks/useStateSelectedG500LiteMasterInfo';
import { SelectedOffsegMasterInfoType } from '../../../common/component/hooks/useStateSelectedOffsegMasterInfo';
import { DialogType } from '../../../common/type/DialogType';
import { formatNowDatetime } from '../../../common/utils/dateHandler';

import { getCurrentCarPlaceHandler } from '../../feature/handler/getCurrentCarPlaceHandler';
import { CurrentCarPlaceInfoType } from '../../feature/type/CurrentCarPlaceInfoType';

type InputType = {
	setIsAsyncProcess: (value: SetStateAction<boolean>) => void;
	selectedOffsegMasterInfo: SelectedOffsegMasterInfoType;
	selectedG500LiteMasterInfo: SelectedG500LiteMasterInfoType;
	setDialog: (value: SetStateAction<DialogType>) => void;
	setCurrentCarPlaceList: (value: React.SetStateAction<CurrentCarPlaceInfoType[]>) => void;
	setLastUpdatedDatetime: (value: React.SetStateAction<string | undefined>) => void;
	setCenteredCurrentCarPlaceInfo: (value: React.SetStateAction<CurrentCarPlaceInfoType | undefined>) => void;
};

/**
 * 車両現在位置一覧取得用カスタムフック
 */
export const useGetCurrentCarPlace = (input: InputType) => {
	const {
		setIsAsyncProcess,
		selectedOffsegMasterInfo,
		selectedG500LiteMasterInfo,
		setDialog,
		setCurrentCarPlaceList,
		setLastUpdatedDatetime,
		setCenteredCurrentCarPlaceInfo,
	} = input;

	// 検索ボタン、更新ボタンを押下した際の処理
	const onClickSearch = async () => {
		// ローディング表示開始
		setIsAsyncProcess(true);

		const requestParams = {
			offsegOrganizationId: selectedOffsegMasterInfo.selectedOffsegOrganizationInfo.id,
			offsegCarId: selectedOffsegMasterInfo.selectedOffsegCarInfo.id,
			offsegDriverId: selectedOffsegMasterInfo.selectedOffsegDriverInfo.id,
			g500LiteOrganizationId: selectedG500LiteMasterInfo.selectedG500LiteOrganizationInfo.id,
			g500LiteCarId: selectedG500LiteMasterInfo.selectedG500LiteCarInfo.id,
		};

		// 車両現在位置一覧を取得
		const [dialog, currentCarPlaceList] = await getCurrentCarPlaceHandler(requestParams);

		// ローディング表示修了
		setIsAsyncProcess(false);

		if (!currentCarPlaceList) {
			setDialog(dialog);
			return;
		}

		setCurrentCarPlaceList(currentCarPlaceList);
		setLastUpdatedDatetime(formatNowDatetime());
		setCenteredCurrentCarPlaceInfo(currentCarPlaceList[0]);
	};

	return { onClickSearch };
};
